import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradeLevels from "./routes/GradeLevels";

export default store => ({
  path: "grade-levels",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "grade-levels" */ "./components/GradeLevelsWrapper"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [GradeLevels(store)],
});
